export const useRouterPage = () => {
  return [
    { label: '工作台', value: '/home/workbench/index', icon: 'm-gongzuotai' },
    { label: '灵感集', value: '/home/coll', icon: 'm-lingganji' },
    { label: '款式图库', value: '/home/all', icon: 'm-kuanshituku' },
    { label: '智能选款', value: '/home/intellectRecommend', icon: 'm-zhinengxuankuan', },
  ]
}
